<template>
  <div>
    <div style="display: flex">
      <AdminHeader :menu_check="false" />
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>대시보드</p>
          <div class="Admin_PageHeader_btn">
            <a :href="homepageLink" target="_blank" class="Admin_PageHeader_goHome">홈페이지 가기</a>
          </div>
        </div>
        <div class="Admin_dashboardWrap">
          <div class="Admin_dashboardBox">
            <div class="Admin_dashboard_dataBox">
              <h2>결제대기 현황</h2>
              <table class="Admin_dashboard_dataTable" v-if="payStatusWaitRows.length !== 0">
                <thead>
                  <tr>
                    <th>예약ID</th>
                    <th>예약신청일</th>
                    <th>출발일</th>
                    <th>예약인원</th>
                    <th>상세보기</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(payStatusWait, index) in payStatusWaitRows" :key="index">
                    <td>{{payStatusWait.reservation_ID}}</td>
                    <td>{{payStatusWait.reservation_registe}}</td>
                    <td>{{payStatusWait.schedule_start_day}}</td>
                    <td>{{payStatusWait.total_reservation_number_count}}명</td>
                    <td>
                      <a :href="`/AdminReservationManagementAdd?reservation_ID=${payStatusWait.reservation_ID}`" class="Admin_dashboard_goBtn">상세보기</a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="Admin_dashboard_dataNo">
                결제대기 데이터가 없습니다.
              </div>
            </div>
            <div class="Admin_dashboard_dataBox">
              <h2>예약취소요청 현황</h2>
              <table class="Admin_dashboard_dataTable" v-if="cancellationRequestRows.length !== 0">
                <thead>
                  <tr>
                    <th>예약ID</th>
                    <th>예약신청일</th>
                    <th>출발일</th>
                    <th>예약인원</th>
                    <th>상세보기</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cancellationRequest, index) in cancellationRequestRows" :key="index">
                    <td>{{cancellationRequest.reservation_ID}}</td>
                    <td>{{cancellationRequest.reservation_registe}}</td>
                    <td>{{cancellationRequest.schedule_start_day}}</td>
                    <td>{{cancellationRequest.total_reservation_number_count}}명</td>
                    <td>
                      <a :href="`/AdminReservationManagementAdd?reservation_ID=${cancellationRequest.reservation_ID}`">이동</a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="Admin_dashboard_dataNo">
                예약취소요청 데이터가 없습니다.
              </div>
            </div>
          </div>
          <!-- 통계잠시닫자 -->
          <!-- <div class="chart-container">
            <div v-for="(chart, index) in chartTypes" :key="index" class="chart-box">
              <canvas :ref="el => chartRefs[index] = el"></canvas>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref, computed, onMounted, nextTick } from 'vue'
import { Chart } from 'chart.js'
import AdminHeader from '../Section/AdminHeader.vue'
import {
  get_session_admin,
  get_reservation_dashboard
} from '../../ETC/Axios.vue'
export default {
  name: 'AdminMain',
  components: {
    AdminHeader
  },
  setup () {
    const chartTypes = ['bar', 'pie', 'line', 'doughnut', 'radar', 'polarArea']
    const chartInstances = ref([])
    const chartRefs = ref([])
    const cancellationRequestRows = ref([])
    const payStatusWaitRows = ref([])
    const admin_number = ref(0)

    const homepageLink = computed(() => {
      return admin_number.value === 0
        ? 'https://happytrain.co.kr/'
        : 'https://happytrain.kr/'
    })
    const initializeCharts = () => {
      chartTypes.forEach((type, index) => {
        const canvas = chartRefs.value[index]

        if (canvas) {
          const ctx = canvas.getContext('2d')
          const chart = new Chart(ctx, {
            type: type,
            data: {
              labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
              datasets: [{
                label: '통계 데이터',
                data: [12, 19, 3, 5, 2, 3],
                borderWidth: 1,
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)'
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)'
                ]
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false
            }
          })
          chartInstances.value.push(chart)
        } else {
          console.warn(`Canvas element chart${index} not found`)
        }
      })
    }

    onMounted(async () => {
      await nextTick()
      initializeCharts()
    })

    return {
      chartTypes,
      chartInstances,
      chartRefs,
      cancellationRequestRows,
      payStatusWaitRows,
      admin_number,
      homepageLink
    }
  },
  mounted () {
    get_session_admin().then(result => {
      this.admin_number = result.admin_number
      get_reservation_dashboard(result.admin_number).then(result_data => {
        this.cancellationRequestRows = result_data.cancellationRequestRows
        this.payStatusWaitRows = result_data.payStatusWaitRows
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Main/AdminMain.vue